export default __webpack_public_path__ + "static/media/m4-02.ce3c47a6.png";